import { SELF_PARTICIPANT_ID } from '../constants';
import { constants as callConstants } from '../../call';
import { PeopleTypeToUserRoleMap } from '../../core';
export const streamToParticipantMapper = (streams) => {
    return streams.map((stream) => {
        return {
            id: stream.id,
            uuid: stream.personConnection.person.uuid,
            /**
             * @NOTE We cannot rely on *stream.hasVideo* because it is calculated based on videoDisabledReasons
             *       with a delay (/providers/video/tokbox/lib/streams/media-stream.ts)
             */
            hasVideo: Boolean(stream.stream)
                ? stream.stream.hasVideo
                : stream.hasVideo,
            hasAudio: stream.hasAudio,
            avatar: stream.personConnection.userPicture,
            name: stream.personConnection.userName,
            videoElementPromise: stream.videoElementPromise,
            role: PeopleTypeToUserRoleMap[stream.personConnection.person.type],
            lastActivity: stream.lastActivity,
            streamType: stream.type,
        };
    });
};
export const createSelfParticipant = (settings) => {
    return {
        id: SELF_PARTICIPANT_ID,
        uuid: SELF_PARTICIPANT_ID,
        name: 'You',
        hasAudio: settings.hasAudio,
        hasVideo: settings.hasVideo,
        avatar: settings.avatar,
        videoElementPromise: settings.videoElementPromise,
        streamType: callConstants.StreamType.Camera,
    };
};
